/**
 * Data export — RGPD art. 20 portabilité (Sprint 1.9 shell utilisateur).
 *
 * Aggrège tous les localStorage `labrain.*` dans un JSON structuré pour téléchargement.
 * Format versioning forward-compat. Sprint 2.1 ajoutera les données serveur Neon.
 */
import { loadUserState } from './user-state';
import { loadProgression } from './game-progression';
export const KNOWN_GAME_SLUGS = [
    'double-decision',
    'memory-grid',
    'visual-sweeps',
    'hawk-eye',
    'color-match',
    'path-finder',
    'sound-sweeps',
    'inhibition',
    'face-facts',
    'face-to-face',
    'mental-map',
    'mind-bender',
];
function readAllLabrainStorage() {
    const out = {};
    if (typeof window === 'undefined')
        return out;
    let storage;
    try {
        storage = window.localStorage;
    }
    catch {
        return out;
    }
    for (let i = 0; i < storage.length; i += 1) {
        const key = storage.key(i);
        if (!key || !key.startsWith('labrain.'))
            continue;
        try {
            const raw = storage.getItem(key);
            if (raw === null)
                continue;
            try {
                out[key] = JSON.parse(raw);
            }
            catch {
                out[key] = raw;
            }
        }
        catch {
            /* ignored */
        }
    }
    return out;
}
export function buildUserDataExport() {
    const progression = {};
    for (const slug of KNOWN_GAME_SLUGS) {
        progression[slug] = loadProgression(slug);
    }
    return {
        version: 1,
        exported_at: new Date().toISOString(),
        user_state: loadUserState(),
        game_progression: progression,
        game_history: [],
        raw_storage: readAllLabrainStorage(),
    };
}
export function exportUserDataAsJson() {
    return JSON.stringify(buildUserDataExport(), null, 2);
}
function pad2(n) {
    return n < 10 ? `0${n}` : String(n);
}
export function buildExportFilename(now = new Date()) {
    const y = now.getFullYear();
    const m = pad2(now.getMonth() + 1);
    const d = pad2(now.getDate());
    return `labrain-data-${y}${m}${d}.json`;
}
export function downloadUserData() {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
    const json = exportUserDataAsJson();
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = buildExportFilename();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
//# sourceMappingURL=data-export.js.map